<script lang="ts">
	import { NavigationMenu } from 'bits-ui';
	import { getCopy } from '$lib/lang/copy.svelte';
	import { activeSection } from '$lib/global.svelte';

	const chapters = $derived(getCopy().menu);
</script>

<NavigationMenu.Root>
	<NavigationMenu.List>
		<NavigationMenu.Item class="relative" openOnHover={false}>
			<NavigationMenu.Trigger
				class="border-blue-lighter data-[state=open]:bg-blue-light hover:bg-blue-light z-50 flex h-fit w-fit cursor-pointer items-center justify-center gap-2 rounded-sm border p-2 transition-colors"
				aria-label="Open navigation menu"
			>
				<iconify-icon
					noobserver
					icon="material-symbols:menu-rounded"
					class="pointer-events-none text-xl text-white"
				></iconify-icon>
			</NavigationMenu.Trigger>

			<NavigationMenu.Content
				class="bg-cream border-gray data-[state=open]:slide-from-top absolute top-full right-0 z-40 mt-2 rounded border shadow data-[state=closed]:hidden"
				forceMount
			>
				{#each chapters as { title, href }, i (i)}
					{@const selected = activeSection.value === href.slice(1)}
					<NavigationMenu.Link
						{href}
						onclick={() => {
							activeSection.value = href.slice(1);
						}}
						class={[
							'button hover:bg-gray hover:text-blue/80 border-gray-dark flex cursor-pointer items-center gap-2 border-b px-3 py-2 whitespace-nowrap last-of-type:border-b-0',
							selected ? '!text-blue' : 'text-gray-dark'
						]}
					>
						{#if selected}
							<div class="bg-red h-2 w-2 rounded-full"></div>
						{/if}
						{title}
					</NavigationMenu.Link>
				{/each}
			</NavigationMenu.Content>
		</NavigationMenu.Item>
	</NavigationMenu.List>
</NavigationMenu.Root>
